import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import DocumentTypePropertyListBrowser from './DocumentTypePropertyListBrowser';
import { useRouteMatch } from 'react-router-dom';
import { areas } from 'constants/areas';
import { getInt } from 'utils/functions';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { withAreaGetter } from 'providers/AreasConsumers';
import HeaderLinks from './header/HeaderLinks';
import Header from './header/Header';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_DOCUMENT_TYPES } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const history = useHistoryWithContext();
  const match = useRouteMatch();
  const documentTypeId = match.params.documentTypeId && getInt(match.params.documentTypeId);

  const onAdd = useCallback(() => {
    history.push(`/documentTypes/${documentTypeId}/documentTypeProperties/new`);
  }, [history, documentTypeId]);

  const onClose = useCallback(() => {
    history.push('/documentTypes');
  }, [history]);

  return (
    <>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_DOCUMENT_TYPES} withForbiddenPage={false}>
          <HeaderLinks onAdd={onAdd} onClose={onClose} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_DOCUMENT_TYPES}>
        <DocumentTypePropertyListBrowser documentTypeId={documentTypeId} />
      </PermissionCheck>
    </>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
